export function convertDateFormat(dateString: string): string {
  if (dateString === "") {
    return "";
  }
  // Split the input date string "MM-DD-YYYY HH:MM:SS"
  const dateParts = dateString.split(/[- :]/);

  // Parse the date parts into a Date object
  const date = new Date(
    parseInt(dateParts[2]), // Year
    parseInt(dateParts[0]) - 1, // Month (0-based index)
    parseInt(dateParts[1]), // Day
    parseInt(dateParts[3]) || 0, // Hours (default to 0 if not provided)
    parseInt(dateParts[4]) || 0, // Minutes (default to 0 if not provided)
    parseInt(dateParts[5]) || 0 // Seconds (default to 0 if not provided)
  );

  // Format the date to "D MMMM YYYY"
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

// format: D MMMM
export function convertDateFormatDDMM(dateString: string): string {
  if (dateString === "") {
    return "";
  }
  return convertDateFormat(dateString)
    .split(",")[0]
    .split(" ")
    .reverse()
    .join(" ");
}
